import styled from 'styled-components';
import media from '../../../styles/Media.styled';
import { FONT_FAMILY_DEMI } from 'src/styles/fonts/MCFontConstants';

/**
 * Styled container for the Step Progress Bar
 * Handles responsive layout across different device sizes
 * 
 * @component
 */
export const StepperContainer = styled.div`
    padding-left: ${({ procedurePageVisibility }) =>
        !procedurePageVisibility ? '0px' : ' 120px'};
    padding-right: ${({ procedurePageVisibility }) =>
        !procedurePageVisibility ? '0px' : ' 120px'};
    height: ${({ height }) => (height ? height : '72px')};
    margin-left: ${({ $marginleftdesk }) => ($marginleftdesk ? $marginleftdesk : '0px')};
    margin-right: ${({ $marginrightdesk }) => ($marginrightdesk ? $marginrightdesk : '0px')};
    ${media.mediumDevice`
             padding-left:${({ ipadPaddingLeft }) =>
                 ipadPaddingLeft ? ipadPaddingLeft : '60px'};
             padding-right: ${({ ipadPaddingRight }) =>
                 ipadPaddingRight ? ipadPaddingRight : '60px'};
              margin-right:${({ marginRight }) =>
                  marginRight ? marginRight : 'unset'};
              margin-left:${({ marginLeft }) =>
                  marginLeft ? marginLeft : 'unset'};
    `}
    ${media.mobileDevice`
             padding-left: 0px;
             padding-right: 0px;
             margin-right:${({ $mbmarginright }) =>
                 $mbmarginright ? $mbmarginright : 'unset'};
              margin-left:${({ $mbmarginleft }) =>
                  $mbmarginleft ? $mbmarginleft : 'unset'};
            //  Size of progress section appears bigger than on mockup
             height: ${({ height }) => (height ? height : '72px')};
            padding: ${({ mbPadding }) => mbPadding};
    `}

    .MuiLinearProgress-root {
        height: 1.5px;
        overflow: hidden;
    }

    .CustomStepper-stepper__step__label {
        font-style: ${FONT_FAMILY_DEMI};
    }
`;
